import moment from "moment";
import { OptionalDatePicker } from "components/DatePicker/OptionalDatePicker";
import { FormSection } from "components/MainSectionTemplate/types";
import OptionalTextInput from "components/ValidatedFields/OptionalTextInput";
import { ContactFormState } from "contact/models";
import { getInstruction } from "contact/utils";
import React from "react";
import { formatShortDate } from "utilities";
import { isNullOrEmptyString } from "shared/utils";

export const passportSection = (contact: server.dto.Contact, formState: ContactFormState): FormSection => {
  return {
    type: "collapsable",
    key: "passportDetails",
    title: RESX.Passport.resxPassport,
    fields: [{
      key: "nationality",
      label: RESX.Passport.Nationality,
      render: () => formState.nationality,
      isEmpty: isNullOrEmptyString(formState.nationality),
      inPageEdit: {
        fullWidth: true,
        render: ({ value, onChange, submit, cancel }) => (
          <OptionalTextInput
            focusOnMount
            value={value}
            onChange={onChange}
            onEnter={submit}
            onEsc={cancel}
            maxLength={serverReference.constants.contact.maxNationalityLength}
          />
        ),
        type: "confirmOrCancelButton",
        initialValue: formState.nationality,
        submitChange: (value: string) => {
          const instruction = getInstruction(contact, formState, { nationality: value });
          return window.CoreApi.Contact.UpdateDetails(instruction);
        }
      }
    }, {
      key: "passportName",
      label: RESX.Passport.NameOnPassport,
      render: () => formState.passportName,
      isEmpty: isNullOrEmptyString(formState.passportName),
      inPageEdit: {
        fullWidth: true,
        render: ({ value, onChange, submit, cancel }) => (
          <OptionalTextInput
            focusOnMount
            value={value}
            onChange={onChange}
            onEnter={submit}
            onEsc={cancel}
            maxLength={serverReference.constants.passport.maxPassportNameLength}
          />
        ),
        type: "confirmOrCancelButton",
        initialValue: formState.passportName,
        submitChange: (value: string) => {
          const instruction = getInstruction(contact, formState, { passportName: value });
          return window.CoreApi.Contact.UpdateDetails(instruction);
        }
      }
    }, {
      key: "passportNumber",
      label: RESX.Passport.PassportNumber,
      render: () => formState.passportNumber,
      isEmpty: isNullOrEmptyString(formState.passportNumber),
      inPageEdit: {
        fullWidth: true,
        render: ({ value, onChange, submit, cancel }) => (
          <OptionalTextInput
            focusOnMount
            value={value}
            onChange={onChange}
            onEnter={submit}
            onEsc={cancel}
            maxLength={serverReference.constants.passport.maxPassportNumberLength}
          />
        ),
        type: "confirmOrCancelButton",
        initialValue: formState.passportNumber,
        submitChange: (value: string) => {
          const instruction = getInstruction(contact, formState, { passportNumber: value });
          return window.CoreApi.Contact.UpdateDetails(instruction);
        }
      }
    }, {
      key: "passportIssued",
      label: RESX.Passport.PassportIssuedOn,
      render: () => formatShortDate(formState.passportIssued),
      isEmpty: formState.passportIssued == null,
      inPageEdit: {
        render: ({ value, onChange }) => (
          <div className="main-section-template-fields-padding">
            <OptionalDatePicker
              focusOnMount
              value={value}
              onChange={v => onChange(v)}
              validatorKey="contactPassportIssued"
              minDate={moment.utc("1900-01-01")}
              maxDate={moment.utc()}
            />
          </div>
        ),
        type: "confirmOrCancelButton",
        initialValue: formState.passportIssued,
        submitChange: (value: moment.Moment | null) => {
          const instruction = getInstruction(contact, formState, {
            passportIssued: value?.toDate(),
          });
          return window.CoreApi.Contact.UpdateDetails(instruction);
        }
      }
    }, {
      key: "passportExpiration",
      label: RESX.Passport.PassportExpiresOn,
      render: () => formatShortDate(formState.passportExpiration),
      isEmpty: formState.passportExpiration == null,
      inPageEdit: {
        render: ({ value, onChange }) => (
          <div className="main-section-template-fields-padding">
            <OptionalDatePicker
              focusOnMount
              value={value}
              onChange={v => onChange(v)}
              validatorKey="contactPassportExpiration"
              minDate={moment.utc("1900-01-01")}
              maxDate={moment.utc().add(30, "years")}
            />
          </div>
        ),
        type: "confirmOrCancelButton",
        initialValue: formState.passportExpiration,
        submitChange: (value: moment.Moment | null) => {
          const instruction = getInstruction(contact, formState, {
            passportExpiration: value?.toDate(),
          });
          return window.CoreApi.Contact.UpdateDetails(instruction);
        }
      }
    }]
  }
}